import React, { useState } from "react";


const ForecastCard = ({ day }) => {
  const [showDetails, setShowDetails] = useState(false);

  const date = new Date(day.dt_txt).toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
  });

  const icon = day.weather[0].icon;
  const temp = Math.round(day.main.temp);
  const wind = day.wind.speed;
  const humidity = day.main.humidity;
  const clouds = day.clouds.all;

  return (
    <div className="forecast-card" onClick={() => setShowDetails(!showDetails)}>
      <h3>{date}</h3>
      <img
        src={`https://openweathermap.org/img/wn/${icon}@2x.png`}
        alt={day.weather[0].description}
      />
      <p>{temp}°C</p>

      {showDetails && (
        <div className="details">
          <p>💨 Wind: {wind} m/s</p>
          <p>☁️ Clouds: {clouds}%</p>
          <p>💧 Humidity: {humidity}%</p>
        </div>
      )}
    </div>
  );
};

export default ForecastCard;
